var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3835 1.5085C2.38436 0.50765 3.88202 0.125 5.8125 0.125H10.3125C12.243 0.125 13.7407 0.50765 14.7415 1.5085C15.7424 2.50936 16.125 4.00702 16.125 5.9375V10.4375C16.125 12.368 15.7424 13.8657 14.7415 14.8665C13.7407 15.8674 12.243 16.25 10.3125 16.25H5.8125C3.88202 16.25 2.38436 15.8674 1.3835 14.8665C0.38265 13.8657 0 12.368 0 10.4375V5.9375C0 4.00702 0.38265 2.50936 1.3835 1.5085ZM2.179 2.304C1.49235 2.99065 1.125 4.11798 1.125 5.9375V10.4375C1.125 12.257 1.49235 13.3843 2.179 14.071C2.86565 14.7577 3.99298 15.125 5.8125 15.125H10.3125C12.132 15.125 13.2593 14.7577 13.946 14.071C14.6327 13.3843 15 12.257 15 10.4375V5.9375C15 4.11798 14.6327 2.99065 13.946 2.304C13.2593 1.61735 12.132 1.25 10.3125 1.25H5.8125C3.99298 1.25 2.86565 1.61735 2.179 2.304Z",
    fill: "url(#paint0_linear_1126_52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14494 9.26845C5.309 9.49428 5.57365 9.62929 5.85295 9.62929H6.72428L6.04118 11.6784C5.95866 11.9259 6.00041 12.2001 6.153 12.4118C6.30559 12.6234 6.55241 12.7497 6.81315 12.7497C7.05632 12.7497 7.28483 12.6422 7.43986 12.4547L10.8193 8.37221C11.0378 8.1083 11.0829 7.75185 10.9369 7.44179C10.7912 7.13198 10.488 6.93935 10.1454 6.93935H9.2404L10.2267 4.60913C10.2614 4.4956 10.2402 4.37231 10.1694 4.27685C10.0986 4.1814 9.98698 4.125 9.86808 4.125H6.97233C6.80998 4.125 6.66618 4.22949 6.61589 4.38379L5.02116 8.48305C4.93449 8.74868 4.98088 9.04213 5.14494 9.26845ZM5.73405 8.71548L7.24455 4.875H9.36198L8.37565 7.20522C8.34098 7.31875 8.36222 7.44204 8.43302 7.5375C8.50382 7.63295 8.6154 7.68935 8.73429 7.68935H10.1454C10.2143 7.68935 10.2458 7.73427 10.2585 7.76113C10.2709 7.78798 10.2856 7.84096 10.2416 7.89419L6.86222 11.9767C6.83659 12.008 6.78508 12.006 6.76139 11.9733C6.7487 11.9555 6.74577 11.9362 6.7526 11.9157L7.60026 9.37294C7.63835 9.25844 7.6193 9.13271 7.54875 9.03505C7.47819 8.93715 7.36515 8.87929 7.24455 8.87929H5.85295C5.79753 8.87929 5.76603 8.84706 5.75187 8.82778C5.73796 8.80849 5.71696 8.76821 5.73405 8.71548Z",
    fill: "url(#paint1_linear_1126_52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1126_52",
    x1: 0.5,
    y1: 1,
    x2: 14.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF70A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394DC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1126_52",
    x1: 0.5,
    y1: 1,
    x2: 14.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF70A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394DC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.d3326ffa38e16319fce1d8316568380d.svg";
export { ForwardRef as ReactComponent };